module.exports = __webpack_public_path__ + "static/media/folder_icon_white.e2cbac91.svg";